export function getEnv() {
    let envLocation = window.location.origin;
    const configuredEndpoint = process.env.REACT_APP_ENDPOINT || process.env.REACT_APP_API_URL || '';
    const configuredSocketEndpoint = process.env.REACT_APP_SOCKET_ENDPOINT || process.env.REACT_APP_WS_ENDPOINT || '';
    const configuredKeycloakUrl = process.env.REACT_APP_KEYCLOAK_URL || '';

    const endpoint = configuredEndpoint || envLocation;
    const socketEndpoint = configuredSocketEndpoint || endpoint;
    const keycloakUrl = configuredKeycloakUrl || `${endpoint}/auth`;

    switch (envLocation) {
        case "http://localhost:3000":
            return {
                ENDPOINT: 'https://codex.indiasouthcentral.cloudapp.azure.com/',
                SOCKET_ENDPOINT: configuredSocketEndpoint || 'https://codex.indiasouthcentral.cloudapp.azure.com/',
                KEYCLOAK_URL: 'https://codexfree.work.gd/auth',
                REALM: 'codex',
                CLIENT_ID: 'codex_public',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // fake, jwt or 'keycloak'
            }

        case "http://192.168.1.100:3000":
            return {
                ENDPOINT: 'http://192.168.1.100:2001',
                SOCKET_ENDPOINT: configuredSocketEndpoint || 'http://192.168.1.100:2001',
                KEYCLOAK_URL: 'https://codexfree.work.gd/auth',
                REALM: 'codex',
                CLIENT_ID: 'codex_public',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // fake, jwt or 'keycloak'
            }

        case "http://localhost:3001":
            return {
                ENDPOINT: 'https://codexfree.work.gd',
                SOCKET_ENDPOINT: 'https://codexfree.work.gd',
                KEYCLOAK_URL: 'https://codexfree.work.gd/auth',
                REALM: 'codex',
                CLIENT_ID: 'codex_public',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // fake, jwt or 'keycloak'
            }

        case "https://codexfree.work.gd":
            return {
                ENDPOINT: 'https://codexfree.work.gd',
                SOCKET_ENDPOINT: 'https://codexfree.work.gd',
                KEYCLOAK_URL: 'https://codexfree.work.gd/auth',
                REALM: 'codex',
                CLIENT_ID: 'codex_public',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // fake, jwt or 'keycloak'
            }

        case "http://20.168.66.168":
            return {
                ENDPOINT: 'http://20.168.66.168',
                SOCKET_ENDPOINT: configuredSocketEndpoint || 'http://20.168.66.168',
                KEYCLOAK_URL: 'http://20.168.66.168/auth',
                REALM: 'codex',
                CLIENT_ID: 'codex_public',
                ENVIRONMENT: 'development',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // fake, jwt or 'keycloak'
            }

        default:
            return {
                ENDPOINT: endpoint,
                SOCKET_ENDPOINT: socketEndpoint,
                KEYCLOAK_URL: keycloakUrl,
                REALM: 'codex',
                CLIENT_ID: 'codex_public',
                ENVIRONMENT: 'production',
                DEBUG_MODE: true,
                LOG_LEVEL: 'debug',
                AUTH_METHOD: 'keycloak' // fake, jwt or 'keycloak'
            }
    }
}

// Helper function to get environment variable with fallback
export function getEnvVar(key, defaultValue = '') {
    const env = getEnv();
    return env[key] || defaultValue;
}

// Helper function to check if we're in development mode
export function isDevelopment() {
    return getEnv().ENVIRONMENT === 'development';
}

// Helper function to check if debug mode is enabled
export function isDebugMode() {
    return getEnv().DEBUG_MODE === true;
}
